import cleanedFilename from '~/util/cleanedFilename';

export default {
  REALWORKS_ACTIVE_TOKENS_DROPDOWN: `${cleanedFilename(
    __filename,
  )}-realworks-active-tokens-dropdown`,
};
